import keyMirror from 'keymirror';
import shareVideoImg from '../../../images/illustrations/supporting/astronaut.svg';
import shareResultsImg from '../../../images/illustrations/supporting/pointerTestStanding.svg';

export const shareModalActionTypes = keyMirror({
	TOGGLE_SHARE_MODAL: null,
	GET_SHARE_LINK: null,
	GET_SHARE_LINK_SUCCESS: null,
	GET_SHARE_LINK_ERROR: null,
	CLEAR_SHARE_MODAL_STATE: null,
});

export const colors = {
	video: '#6045fb',
	song: '#fd6dfc',
	results: '#fd6dfc',
};

export const shareImages = {
	video: shareVideoImg,
	song: shareVideoImg,
	results: shareResultsImg,
};
